import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { debounceTime } from 'rxjs/operators';
import { TrackingsService } from '../../../services/tracking.service';
import { NonCompliancePanelComponent } from '../../panels/checkout/components/non-compliance-panel/non-compliance-panel.component';
import { FittingResponse } from '../../models/santander-suitability/santander-suitability.model';

@Component({
  selector: 'checkout-suitability-disclaimer',
  templateUrl: './checkout-suitability-disclaimer.component.html',
  styleUrls: ['checkout-suitability-disclaimer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})

export class CheckoutSuitabilityDisclaimerComponent implements OnInit {
  @Input('suitability') public suitability: string;
  @Input('isSantanderFeatureFlagEnabled') public isSantanderFeatureFlagEnabled: boolean;
  @Input('fitting') public fitting: FittingResponse;
  @Output('riskAgreementAccepted') public riskAgreementAccepted: EventEmitter<boolean> = new EventEmitter();

  public riskAgreementChecked = false;
  public form: FormGroup;

  public constructor(
    private formBuilder: FormBuilder,
    protected dialogsService: DialogsService,
    private cdr: ChangeDetectorRef,
    private trackingService: TrackingsService,
  ) {
    this.createManualForm();
  }

  public ngOnInit() {
    // Component initialization
  }

  public createManualForm() {
    this.form = this.formBuilder.group({ riskAgreementChecked: false });

    this.form.get('riskAgreementChecked').valueChanges.pipe(debounceTime(0))
      .subscribe(value => {
        this.riskAgreementAccepted.emit(value);
        this.cdr.detectChanges();
      });
  }

  public openNonCompliancePanel() {
    console.log('Opening Non Compliance Panel');
    console.log('Fitting data:', this.fitting);

    this.trackingService.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Bolsa',
      'Element': 'Link termo de desenquadramento',
      'Group': 'Card desenquadramento',
      'Step': 'Resumo do investimento',
      'Scenario': 'Não se aplica',
      'Status': 'Não se aplica',
      'Time Responsável': 'Roebling',
    });

    const dialogRef = this.dialogsService.showComponentAsAsidePanel(
      NonCompliancePanelComponent,
      true,
      { fitting: this.fitting }
    );

    console.log('Dialog opened:', dialogRef);

    if (dialogRef) {
      dialogRef.afterOpened().subscribe(() => {
        console.log('Dialog afterOpened triggered');
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log('Dialog closed with result:', result);
      });
    }
  }
}
